import React, { useState } from "react";
import { Card, Form, Input, Button, Typography, Alert, theme } from "antd";
import { useNavigate } from 'react-router-dom';
import { UserOutlined, MailOutlined, SafetyOutlined } from "@ant-design/icons";
import Logo from "../../../assets/logo/logo.svg";
import Limage from "../../../assets/bill.svg";
import validateForm from '../../../utils/FormValidation';
import validationRules from '../../../assets/validation/rules';
import AuthRestAPI from '../../../restAPI/AuthRestAPI';
import { useSelector } from 'react-redux';
import Config from '../../../utils/Config';

const { Title } = Typography;

const MoguLogin = () => {
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const [countdown, setCountdown] = useState(0);
  const [showSuccess, setShowSuccess] = useState(false);
  const [showFail, setShowFail] = useState(false);
  const [payload, setPayload] = useState({
    username: "",
    password: "",
  });
  const { token } = useSelector(state => state.auth);
  const [errors, setErrors] = useState({});
  const onFinish = (values) => {
    console.log("Form values:", values);
  };

  const handleNavigateToLogin = () => {
    navigate('/login');
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Form failed:", errorInfo);
  };

  const handleSendResetLink = () => {
    if(payload["username"] !== ""){
    // call forgot password
    forgotPassword();
   }
  };

  const forgotPassword = async () => {
    setIsButtonDisabled(true);
    const formData = {"email": payload["username"]};
    //alert(JSON.stringify(formData));
    await AuthRestAPI.forgotPassword(token, localStorage.getItem('groupId'), localStorage.getItem('companyId'), formData)
    .then((res) => {
      console.log("success in forgot password :", res.message); 
      successProcess();
    }).catch(err => {
        console.log("error in forgot password :", err.message);
        failProcess();
    })
  };

  const successProcess = async () => {
    setCountdown(15);
    setShowSuccess(true); // Show the success alert

    // Hide the success alert after 7 seconds
    setTimeout(() => {
      setShowSuccess(false);
    }, 7000);

    const interval = setInterval(() => {
      setCountdown((prev) => {
        if (prev === 1) {
          clearInterval(interval);
          setIsButtonDisabled(false);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
  }

  const failProcess = async () => {
    setCountdown(15);
    setShowFail(true);

    setTimeout(() => {
      setShowFail(false);
    }, 7000);

    const interval = setInterval(() => {
      setCountdown((prev) => {
        if (prev === 1) {
          clearInterval(interval);
          setIsButtonDisabled(false);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
  }

   const {
    token: { colorTextQuaternary },
  } = theme.useToken();

  const navigate = useNavigate();

  function validateFormData(data) {
    const validationResult = validateForm(data, validationRules)
    if (!validationResult.isValid) {
      setIsButtonDisabled(true);
      const err = validationResult.errors
      const newErrors = {};
      Object.keys(err).forEach((value) => {
        newErrors[value] = err[value];
      })
      setErrors(prev => ({ ...prev, ...newErrors }));
    } else {
      setIsButtonDisabled(false);
      const keyData = Object.keys(data)[0]
      setErrors(prev => ({ ...prev, [keyData]: '' }))
    }
  }

  // Check if new design should be used
  const isNewDesign = Config.LOGIN_PAGE_DESIGN === 'new';

  return (
    <div className="login-page">
      <div className="login-container">
        {/* Left Section */}
        <div className={`left-section ${isNewDesign ? 'left-section-new' : 'left-section-old'}`}>
          {/* Multiple decorative 3D shapes for layered effect - Only for new design */}
          {isNewDesign && (
            <>
              <div className="decorative-shape-1"></div>
              <div className="decorative-shape-2"></div>
              <div className="decorative-shape-3"></div>
              <div className="decorative-shape-4"></div>
              <div className="decorative-shape-5"></div>
              <div className="decorative-shape-6"></div>
              <div className="decorative-shape-7"></div>
              <div className="decorative-shape-8"></div>
              <div className="decorative-shape-9"></div>
              <div className="decorative-shape-10"></div>
            </>
          )}
          
          <center>
            <h1 style={{fontWeight:'400'}}>
              mogu <br />
              <span>e-Invoicing System</span>
            </h1>
            <br />
            <br />
            <img src={Limage} style={{ width: "50%" }} alt="Left Section" />
          </center>
        </div>

        {/* Right Section */}
        <div className="border-container right-section" style={{ width: "50%" }}>
          <Button
            type="primary"
            className="card-button"
            style={{ pointerEvents: "none" }}
            size="large"
            icon={<SafetyOutlined />}
            shape="circle"
          ></Button>
          <Card className="right-card">
            <div
              className="logo"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <center>
                <Title level={1} className="logotext login-logo" style={{ fontSize: '4rem' }}>
                  <span style={{ display: "flex", alignItems: "center" }}>
                    <img
                      style={{ width: 52, marginTop: -15 }}
                      src={Logo}
                      alt="Logo"
                    />{" "}
                    mogu
                  </span>
                </Title>
              </center>
            </div>
            {/* Success Alert */}
            {showSuccess && (
              <Alert
                //message="Success"
                description="Password reset link has been sent to your email address."
                type="success"
                showIcon
                style={{ marginBottom: 20 }}
              />
            )}
            {/* Fail Alert */}
            {showFail && (
              <Alert
                description="If the email address is registered, you will receive a password reset link shortly. Otherwise, please check your entry."
                type="error"
                showIcon
                style={{ marginBottom: 20 }}
              />
            )}
            <center>
              <h2>Reset Password</h2>
              <p className="subtitle">
                Forget your password? Please enter the email associated with your account and we'll send you a password reset link.
              </p>
            </center>
            <Form
              layout="vertical"
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
            >
              <Form.Item validateStatus={errors.forgotPasswordEmail ? 'error' : ''} help={errors.forgotPasswordEmail || ''} required>
                <Input
                   name="email"
                  size="large"
                  placeholder="Enter Your Email Address"
                  onChange={(e) => {
                    const validateData = {
                      forgotPasswordEmail: e.target.value
                    }
                    validateFormData(validateData);
                    setPayload(prev => ({
                      ...prev,
                      username: e.target.value
                    }));
                  }}
                  value={payload["username"]}
                  prefix={<UserOutlined style={{color:colorTextQuaternary}} />}
                />
              </Form.Item>
              <Form.Item>
                <Button
                  type="primary"
                  size="large"
                  icon={<MailOutlined />}
                  onClick={handleSendResetLink}
                  disabled={isButtonDisabled}
                  block
                >
                  Send Reset Link
                </Button>
                
                {countdown > 0 && (
                  <p style={{ textAlign: "center", marginTop: "10px" }}>
                    Please wait {countdown} seconds...
                  </p>
                )}
              </Form.Item>
              <Form.Item>
              <Button type="link" block onClick={handleNavigateToLogin}>
                      Go to Login
                    </Button>
              </Form.Item>
            </Form>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default MoguLogin;
